import { createReducerContext } from '../../../../utils/create-reducer-context';
import { ParametersState, ParametersReducer, ACTION_TYPES } from './parameters-reducer';
import { toParametersForm } from '../components/parameters-utils';

const initialState: ParametersState = {
    form: toParametersForm(),
    loading: false,
    isDirty: false,
    showValidationErrors: false,
    tab: 0,
};

const { Provider: ParametersProvider, useStateContext: useParametersState, useDispatchContext: useParametersDispatch } = createReducerContext('Parameters', ParametersReducer, initialState);

export { ParametersProvider, useParametersState, useParametersDispatch, ACTION_TYPES };
